module.exports = __webpack_public_path__ + "img/GOLOS.70b8b4c1.svg";